module.exports = __webpack_public_path__ + "img/tbA.3bf2974e.png";